import * as types from '../constants/action-types';

const initialState = {
  isFetching: false,
  index: null
};

export default function add_ons (state = initialState, action) {
  const { type, index, step } = action;

  switch (type) {
  case types.ADDONS_INDEX_UPDATE:
    return {
      ...state,
      index
    };

  case types.ADDONS_STEP_UPDATE:
    return {
      ...state,
      step
    };

  default:
    return state;
  }
}
